import { GameScatterPickBackgroundProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameScatterPickBackgroundProperties";
export class ScatterPickBackgroundLandscapeProperties extends GameScatterPickBackgroundProperties {
    constructor() {
        super();
        this.position.set(973, 512);
        this.titleSpineProperties.position.set(0, -350);
        this.titleSpineProperties.scale.set(0.73);
        this.instructionsProperties.position.set(0, 280);
    }
}
//# sourceMappingURL=ScatterPickBackgroundLandscapeProperties.js.map